export const SET_USER_INFO = "SET_USER_INFO";
